<div class="auth-container">

  <div class="auth-card">

    <h2 class="auth-title">Activemos tu cuenta</h2>

    <p class="auth-subtitle">
      Bienvenido <strong>{{ this.user?.name }}</strong>!<br>
      Configuremos tu contraseña para que puedas reservar pasajes por cuenta de 
      <strong>{{ this.user?.company.name }}</strong>.
    </p>

    <form [formGroup]="form" #f="ngForm" (submit)="ok()">

      <div class="form-group">
        <label>Contraseña</label>
        <input
          type="password"
          class="form-control"
          autocomplete="new-password"
          formControlName="password"
          [class.is-invalid]="f.submitted && form.controls.password.invalid"
        >

        <div class="invalid-feedback" *ngIf="form.controls.password.hasError('required')">
          Por favor, ingresá una contraseña.
        </div>

        <div class="invalid-feedback" *ngIf="form.controls.password.hasError('minlength')">
          Tu contraseña debe tener al menos {{ form.controls.password.errors.minlength.requiredLength }} caracteres.
        </div>
      </div>

      <div class="form-group">
        <label>Contraseña, otra vez</label>
        <input
          type="password"
          class="form-control"
          autocomplete="new-password"
          formControlName="passwordConfirmation"
          [class.is-invalid]="f.submitted && (form.errors || form.controls.passwordConfirmation.invalid)"
        >

        <div class="invalid-feedback" *ngIf="form.errors">
          Las contraseñas son distintas.
        </div>

        <div class="invalid-feedback" *ngIf="form.controls.passwordConfirmation.hasError('required')">
          Por favor, confirmá tu contraseña.
        </div>
      </div>

      <button class="btn btn-success btn-block btn-lg mt-3">
        Activar mi cuenta
      </button>

    </form>

  </div>

</div>